export default __webpack_public_path__ + "static/media/al_karamah_logo.2029cb00.png";